import { Site } from '@umanforge/common';
import { PostSite } from '../interfaces/api_site.interfaces';

export const DEFAULT_POST_SITE: PostSite = { clientId: '', name: '', address: '', additionalAddress: '', zipCode: '', city: '', country: '', admins: [] };
export const getCreateSite: ( t: ( str: string ) => string  ) => Site = t => {
  return { ...DEFAULT_POST_SITE, id: 'new_site', name: t( 'Create new site' ), isAdmin: undefined, sectors: undefined, sftpPublicKey: null, sftpUsername: null };
};